var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3999 20.3409C34.3999 19.2772 34.3044 18.2545 34.1272 17.2727H19.9999V23.075H28.0726C27.7249 24.95 26.6681 26.5386 25.0794 27.6022V31.3659H29.9271C32.7635 28.7545 34.3999 24.9091 34.3999 20.3409Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 35.0001C24.0502 35.0001 27.4457 33.6569 29.9275 31.366L25.0798 27.6024C23.7366 28.5024 22.0184 29.0342 20.0002 29.0342C16.0934 29.0342 12.7866 26.3956 11.6071 22.8501H6.5957V26.7365C9.06388 31.6387 14.1366 35.0001 20.0002 35.0001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6071 22.85C11.3071 21.95 11.1366 20.9887 11.1366 20C11.1366 19.0114 11.3071 18.05 11.6071 17.15V13.2637H6.5957C5.57979 15.2887 5.00024 17.5796 5.00024 20C5.00024 22.4205 5.57979 24.7114 6.5957 26.7364L11.6071 22.85Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 10.9659C22.2025 10.9659 24.1798 11.7227 25.7343 13.2091L30.0366 8.90682C27.4389 6.48636 24.0434 5 20.0002 5C14.1366 5 9.06388 8.36136 6.5957 13.2636L11.6071 17.15C12.7866 13.6045 16.0934 10.9659 20.0002 10.9659Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGg);
export default __webpack_public_path__ + "static/media/icon_gg.11ae76542428c3d1c0cefcc7b10f766c.svg";
export { ForwardRef as ReactComponent };